var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("PageHeader", {
        attrs: {
          icon: "pending_actions",
          title: _vm.fileName,
          "no-padding": "",
        },
        scopedSlots: _vm._u(
          [
            _vm.show
              ? {
                  key: "subtitle",
                  fn: function () {
                    return [
                      _c("v-divider"),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { attrs: { dark: "" } },
                        [
                          _c("StatusChip", {
                            attrs: {
                              icon: _vm.reviewStatus.icon,
                              "icon-color": _vm.reviewStatus.color,
                              title: "Ingestion Outcome",
                              text: _vm.reviewStatus.text,
                            },
                          }),
                          _vm._v(" "),
                          _c("StatusChip", {
                            attrs: {
                              title: "Ingestion Date",
                              text: _vm.ingestionDate,
                            },
                          }),
                          _vm._v(" "),
                          _c("ExecutionFileVersionChip", {
                            attrs: {
                              fileVersions: _vm.fileVersions,
                              isLatestVersion:
                                _vm.executionResults.IsLatestVersion,
                            },
                            on: {
                              "click:version": () =>
                                this.$router.push(_vm.$event.to),
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        { attrs: { dark: "" } },
                        [
                          _vm.states.hasJustResubmitted
                            ? _c("StatusChip", {
                                attrs: {
                                  icon: "info",
                                  "icon-color": "success lighten-2",
                                  title: "Review status",
                                  text: "Ingested successfully",
                                },
                              })
                            : _vm.states.canResubmit
                            ? _c("StatusChip", {
                                attrs: {
                                  icon: "info",
                                  "icon-color": "info lighten-2",
                                  title: "Review status",
                                  text: _vm.hasBeenIngested
                                    ? "No errors &ndash; ready for reingestion"
                                    : "Ready for ingestion",
                                },
                              })
                            : _c("StatusChip", {
                                attrs: {
                                  icon: "error",
                                  "icon-color": "error lighten-2",
                                  title: "Review status",
                                  text: "Must checkout all errors",
                                },
                              }),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
      _vm._v(" "),
      _vm.show
        ? _c(
            "v-card",
            [
              _c(
                "v-card-actions",
                { staticClass: "card-bg-2 py-0 layout wrap" },
                [
                  _c("UpdateAndIngestExecutionResults", {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function ({ submit, loading }) {
                            return [
                              _vm.isTenantAdmin
                                ? _c(
                                    "PrimaryBtn",
                                    {
                                      staticClass: "my-2 ml-0 mr-2",
                                      staticStyle: { "min-width": "160px" },
                                      attrs: {
                                        icon: "publish",
                                        loading: loading,
                                        disabled:
                                          _vm.states.canResubmit ||
                                          !_vm.executionResults.IsLatestVersion,
                                      },
                                      on: {
                                        "submit:success": function ($event) {
                                          return _vm.onIngestSuccess()
                                        },
                                        click: function ($event) {
                                          return submit(_vm.fileId)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n          " +
                                          _vm._s(
                                            _vm.hasBeenIngested
                                              ? "Reingest"
                                              : "Ingest"
                                          ) +
                                          "\n        "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2003697919
                    ),
                  }),
                  _vm._v(" "),
                  _c(
                    "SecondaryBtn",
                    {
                      staticClass: "my-2 ml-0 mr-2",
                      staticStyle: { "min-width": "160px" },
                      attrs: {
                        to: { name: "dataset", params: { id: _vm.fileId } },
                        icon: "description",
                      },
                    },
                    [_vm._v("\n        View file details\n      ")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }